/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrganizationGroupModel } from './OrganizationGroupModel';
import {
    OrganizationGroupModelFromJSON,
    OrganizationGroupModelFromJSONTyped,
    OrganizationGroupModelToJSON,
    OrganizationGroupModelToJSONTyped,
} from './OrganizationGroupModel';
import type { EmergencyEmailContact } from './EmergencyEmailContact';
import {
    EmergencyEmailContactFromJSON,
    EmergencyEmailContactFromJSONTyped,
    EmergencyEmailContactToJSON,
    EmergencyEmailContactToJSONTyped,
} from './EmergencyEmailContact';

/**
 * 
 * @export
 * @interface OrganizationOnAzure
 */
export interface OrganizationOnAzure {
    /**
     * 
     * @type {string}
     * @memberof OrganizationOnAzure
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationOnAzure
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationOnAzure
     */
    company_name: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationOnAzure
     */
    email?: string | null;
    /**
     * 
     * @type {{ [key: string]: OrganizationGroupModel; }}
     * @memberof OrganizationOnAzure
     */
    groups: { [key: string]: OrganizationGroupModel; };
    /**
     * 
     * @type {string}
     * @memberof OrganizationOnAzure
     */
    join_org_pin?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationOnAzure
     */
    phone_number: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationOnAzure
     */
    primary_contact: string;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof OrganizationOnAzure
     */
    roles_with_features_custom?: { [key: string]: Array<string>; } | null;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof OrganizationOnAzure
     */
    roles_with_features_default: { [key: string]: Array<string>; };
    /**
     * 
     * @type {Array<string>}
     * @memberof OrganizationOnAzure
     */
    features?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationOnAzure
     */
    is_safeguard_organization: boolean;
    /**
     * 
     * @type {number}
     * @memberof OrganizationOnAzure
     */
    subscription_start_timestamp: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationOnAzure
     */
    trial_end_timestamp?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationOnAzure
     */
    last_trial_end_remap_timestamp?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationOnAzure
     */
    subscription_count: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationOnAzure
     */
    ops_subscription_count: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationOnAzure
     */
    respond_subscription_count: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationOnAzure
     */
    subscription_end_timestamp: number;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationOnAzure
     */
    require_join_approval: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrganizationOnAzure
     */
    object_type: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationOnAzure
     */
    unique_key: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationOnAzure
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationOnAzure
     */
    _etag: string;
    /**
     * 
     * @type {number}
     * @memberof OrganizationOnAzure
     */
    _ts: number;
    /**
     * 
     * @type {Array<EmergencyEmailContact>}
     * @memberof OrganizationOnAzure
     * @deprecated
     */
    admin_emergency_emails: Array<EmergencyEmailContact>;
}

/**
 * Check if a given object implements the OrganizationOnAzure interface.
 */
export function instanceOfOrganizationOnAzure(value: object): value is OrganizationOnAzure {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('company_name' in value) || value['company_name'] === undefined) return false;
    if (!('groups' in value) || value['groups'] === undefined) return false;
    if (!('phone_number' in value) || value['phone_number'] === undefined) return false;
    if (!('primary_contact' in value) || value['primary_contact'] === undefined) return false;
    if (!('roles_with_features_default' in value) || value['roles_with_features_default'] === undefined) return false;
    if (!('is_safeguard_organization' in value) || value['is_safeguard_organization'] === undefined) return false;
    if (!('subscription_start_timestamp' in value) || value['subscription_start_timestamp'] === undefined) return false;
    if (!('subscription_count' in value) || value['subscription_count'] === undefined) return false;
    if (!('ops_subscription_count' in value) || value['ops_subscription_count'] === undefined) return false;
    if (!('respond_subscription_count' in value) || value['respond_subscription_count'] === undefined) return false;
    if (!('subscription_end_timestamp' in value) || value['subscription_end_timestamp'] === undefined) return false;
    if (!('require_join_approval' in value) || value['require_join_approval'] === undefined) return false;
    if (!('object_type' in value) || value['object_type'] === undefined) return false;
    if (!('unique_key' in value) || value['unique_key'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('_etag' in value) || value['_etag'] === undefined) return false;
    if (!('_ts' in value) || value['_ts'] === undefined) return false;
    if (!('admin_emergency_emails' in value) || value['admin_emergency_emails'] === undefined) return false;
    return true;
}

export function OrganizationOnAzureFromJSON(json: any): OrganizationOnAzure {
    return OrganizationOnAzureFromJSONTyped(json, false);
}

export function OrganizationOnAzureFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationOnAzure {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'address': json['address'],
        'company_name': json['company_name'],
        'email': json['email'] == null ? undefined : json['email'],
        'groups': (mapValues(json['groups'], OrganizationGroupModelFromJSON)),
        'join_org_pin': json['join_org_pin'] == null ? undefined : json['join_org_pin'],
        'phone_number': json['phone_number'],
        'primary_contact': json['primary_contact'],
        'roles_with_features_custom': json['roles_with_features_custom'] == null ? undefined : json['roles_with_features_custom'],
        'roles_with_features_default': json['roles_with_features_default'],
        'features': json['features'] == null ? undefined : json['features'],
        'is_safeguard_organization': json['is_safeguard_organization'],
        'subscription_start_timestamp': json['subscription_start_timestamp'],
        'trial_end_timestamp': json['trial_end_timestamp'] == null ? undefined : json['trial_end_timestamp'],
        'last_trial_end_remap_timestamp': json['last_trial_end_remap_timestamp'] == null ? undefined : json['last_trial_end_remap_timestamp'],
        'subscription_count': json['subscription_count'],
        'ops_subscription_count': json['ops_subscription_count'],
        'respond_subscription_count': json['respond_subscription_count'],
        'subscription_end_timestamp': json['subscription_end_timestamp'],
        'require_join_approval': json['require_join_approval'],
        'object_type': json['object_type'],
        'unique_key': json['unique_key'],
        'id': json['id'],
        '_etag': json['_etag'],
        '_ts': json['_ts'],
        'admin_emergency_emails': ((json['admin_emergency_emails'] as Array<any>).map(EmergencyEmailContactFromJSON)),
    };
}

export function OrganizationOnAzureToJSON(json: any): OrganizationOnAzure {
    return OrganizationOnAzureToJSONTyped(json, false);
}

export function OrganizationOnAzureToJSONTyped(value?: OrganizationOnAzure | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'address': value['address'],
        'company_name': value['company_name'],
        'email': value['email'],
        'groups': (mapValues(value['groups'], OrganizationGroupModelToJSON)),
        'join_org_pin': value['join_org_pin'],
        'phone_number': value['phone_number'],
        'primary_contact': value['primary_contact'],
        'roles_with_features_custom': value['roles_with_features_custom'],
        'roles_with_features_default': value['roles_with_features_default'],
        'features': value['features'],
        'is_safeguard_organization': value['is_safeguard_organization'],
        'subscription_start_timestamp': value['subscription_start_timestamp'],
        'trial_end_timestamp': value['trial_end_timestamp'],
        'last_trial_end_remap_timestamp': value['last_trial_end_remap_timestamp'],
        'subscription_count': value['subscription_count'],
        'ops_subscription_count': value['ops_subscription_count'],
        'respond_subscription_count': value['respond_subscription_count'],
        'subscription_end_timestamp': value['subscription_end_timestamp'],
        'require_join_approval': value['require_join_approval'],
        'object_type': value['object_type'],
        'unique_key': value['unique_key'],
        'id': value['id'],
        '_etag': value['_etag'],
        '_ts': value['_ts'],
        'admin_emergency_emails': ((value['admin_emergency_emails'] as Array<any>).map(EmergencyEmailContactToJSON)),
    };
}

